import { dictionaryList, REGISTRIES } from '../../../config/languages';
import { RegistryMapper } from '../../../utils/mappers/RegistryMapper';
import { setConfigStateById } from '../ConfigContext';

export const setRegistry = (setState: setConfigStateById) => (registry: typeof REGISTRIES) => {
  setState('SET_REGISTRY', (s) => {
    const registryValues = RegistryMapper.hydrate(registry);
    return {
      ...s,
      registry: registryValues,
      dictionaryValues: dictionaryList[s.language][registryValues],
    };
  });
};
